
import Datetime from 'vux/src/components/datetime/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

export default {
name: "double-date",
components:{
Datetime
},
data() {
return {
dateTitle:'',
startTime:'',
endTime:'',
show:false,
}
},

methods: {
dateChoosed(){
if(this.startTime && this.endTime){
if(new Date(this.startTime) - new Date(this.endTime)>0){
this.$vux.toast.text('开始日期不能大于结束日期！');
}else {
this.show=false;
this.$emit('date-choose',{startTime:dateFormat( new Date(this.startTime).getTime()-8*60*60*1000,"YYYY-MM-DD HH:mm:ss"),endTime:dateFormat(new Date(this.endTime).getTime()+16*60*60*1000-1,"YYYY-MM-DD HH:mm:ss"),show:false})
}
}else if(this.startTime && !this.endTime){
this.$vux.toast.text('请选择结束日期！');
}else if(!this.startTime && this.endTime){
this.$vux.toast.text('请选择开始日期！');
}else if(!this.startTime && !this.endTime){
this.show=false
this.$emit('date-choose',{show:false})
}
},
chooseDate(e){
this.isDateChoosed=!this.isDateChoosed;
this.dateTitle=e;
},
showpop(){
this.show=!this.show;
},
confirm(){
this.show=false;
},
resetTime(){
this.startTime='';
this.endTime='';
},
checkerChange(value,name,chinese,option="IN"){
this.checkedDtoList=this.checkedDtoList.filter(val=>val.name!=name)
this.checkedDtoList.push({name,code:value,ch:chinese,option:option});
},

},
created(){
},

}



// WEBPACK FOOTER //
// ./src/components/manual-search/double-date.vue